<template>
    <div :class="getCSSClass('searchable-select-main')"  ref="container">
        <div :class="getCSSClass('searchable-select-container')" v-if="items">
            <div :class="getCSSClass('searchable-select-selected-container')" v-if="multiple">
                <span v-for="item, index in selectedItems"
                      :class="getCSSClass('searchable-select-item-span')"
                      :key="index"
                >
                    {{ item.label }}
                    <span :class="getCSSClass('searchable-select-remove-button')"
                          v-if="allowRemove"
                          v-on:click="removeItem(index)"
                          v-html="icon('close')"
                    ></span>
                </span>
                <div style="position: relative; display: flex; align-items: center; width: auto; max-width: 100%; min-width: 10rem" :ref="'input-container'">
                    <input type="text" :class="getCSSClass('searchable-select-input')"
                           readonly
                           style="width: 100%; padding-right:40px; order: 9999"
                           v-bind:value="selectedItemLabel"
                           :placeholder="placeholderLabel"
                           v-bind:style="{'color': invalidItem ? 'red' : 'black', 'background-color': disabled ? '#e9ecef' : 'white'}"
                           v-on:keyup.arrow-down="moveDropdownSelection(1)"
                           v-on:keyup.arrow-up="moveDropdownSelection(-1)"
                           v-on:click="openDropdown = !openDropdown"
                    >
                    <span ref="caret"
                          v-if="!disabled"
                          style="position: absolute; right: .3rem; transition: transform 100ms ease-in-out; cursor:pointer; transform-origin:center"
                          v-on:click="openDropdown = !openDropdown"
                          :class="caretClass"
                          v-html="icon('caret-left')"
                    ></span>
                </div>

            </div>
        </div>

        <div :class="getCSSClass('searchable-select-dropdown')"
             style="position: fixed; transition: opacity 200ms ease-in-out, visibility 200ms ease-in-out; z-index: 50"
             v-show="shouldShowDropdown" ref="dropdown">
            <input type="text" :class="getCSSClass('searchable-select-input')"
                   ref="input"
                   v-model="filterText"
                   :placeholder="placeholderLabel"
                   v-bind:style="{'color': invalidItem ? 'red' : 'black'}"
                   v-on:keyup.arrow-down="moveDropdownSelection(1)"
                   v-on:keyup.arrow-up="moveDropdownSelection(-1)"
                   v-on:keyup.escape="resetFilterTextIfNeeded"
                   v-on:keyup.enter="addSelectedFromDropdownOrInput"
            >
            <div :class="getCSSClass('searchable-select-dropdown-list')">
                <div v-for="subject, index in filteredAvailableItems"
                     :key="index"
                     ref="index"
                     v-html="subject.label"
                     v-on:mouseover="dropdownSelectedIndex = index"
                     :class="itemClass(subject, index)"
                     :title="subject.disabledTitle"
                     v-on:click="addItem(subject)"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {searchableSelectMixin} from "./mixins/searchableSelectMixin";

    export default {
        mixins: [searchableSelectMixin]
    }
</script>
<style>
    .searchable-select-main {
        position: relative;
    }
    .searchable-select-container {
        display: flex;
        flex-direction:row;
        flex-wrap: wrap;
        align-items: stretch;
        /*border: 1px solid darkgrey;*/
        width: 100%;
        max-width: 100%;
    }
    .searchable-select-selected-container {
        display: flex;
        flex-wrap: wrap;
        max-height: 12em;
        overflow-y: auto;
        align-items: stretch;
    }
    .searchable-select-item-span {
        margin: 3px;
        margin-left: 0px !important;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .searchable-select-remove-button {
        margin-left: .5rem;
        cursor: pointer;
        user-select: none;
    }
    .searchable-select-dropdown {
        z-index: 1000;
        max-height: 20rem;
        display: flex;
        flex-direction: column;
        box-shadow: 0 20px 25px -3px rgba(0, 0, 0, 0.1), 0 10px 14px -4px rgba(0, 0, 0, 0.05);
    }

    .searchable-select-dropdown-list {
        overflow-y: scroll;
        height: 80%;
        width: 100%;
    }
    .searchable-select-dropdown-list > div {
        cursor:pointer;
    }
    .searchable-select-dropdown-list > div.searchable-select-selected {
        font-weight:bold;
    }
    .searchable-select-dropdown-caret-open {
        transform: rotate(-90deg);
    }
    .searchable-select-item-disabled {
        cursor: not-allowed !important;
        opacity: .5;
    }
    .searchable-select-undefined-item {
    }
    .searchable-select-available-item {
        line-height: normal;
    }

</style>
